<template>
    <!-- 项目自然情况 -->
    <div>
        <!-- <div style="font-size:20px;float:left;margin:40px;font-weight:600">项目自然情况</div> -->
        <div style="height:750px;background-color:white;margin:5px 5px 20px 5px;padding-bottom: 20px;">
            <!-- 查询框 -->
            <div style="margin-left:3%">
                <el-row style=" padding: 20px 0;">
                    <el-col :span="6">
                        <div style="display:inline-block">
                            <span>组织架构</span>
                            <el-cascader v-model="condition.organize_ids" clearable style="margin-left:10px;width:300px"
                                collapse-tags :props="props"></el-cascader>
                        </div>
                    </el-col>
                    <!-- <el-col :span="4">
                        <span>时间</span>
                        <el-date-picker v-model="condition.years_date" type="month" placeholder="请选择" :clearable="false"
                            value-format="yyyy-MM" style="margin-left: 10px;width: 70%;">
                        </el-date-picker>
                    </el-col> -->
                    <el-col :span="1.5">
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Find">
                            查询</el-button>
                    </el-col>
                    <el-col :span="2">
                        <download-excel class="export-excel-wrapper" :fields="download_excel" name="项目自然情况报表"
                            :fetch="ExportForm" style="top:100px;width:5%">
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;margin-left: 14px;">
                                导出</el-button>
                        </download-excel>
                    </el-col>
                </el-row>
            </div>
            <!-- 表格 -->
            <div style="margin:0 3%;margin-top:5px">
                <el-row>
                    <el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" height="574px"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                        style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column align="center" label="序号">
                            <template slot-scope="scope_1">
                                {{ scope_1.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="businessDivision" align="center" label="架构"></el-table-column>
                        <el-table-column prop="projectName" align="center" label="项目"></el-table-column>
                        <el-table-column prop="contractStartDate" align="center" label="开始日期"></el-table-column>
                        <el-table-column prop="contractEndDate" align="center" label="终止日期"></el-table-column>
                        <el-table-column prop="isExpire" align="center" label="到期提醒"></el-table-column>
                        <el-table-column prop="contractHeadcount" align="center" label="合同人数"></el-table-column>
                        <el-table-column prop="contractUnit" align="center" label="单位"></el-table-column>
                        <el-table-column prop="unitPrice" align="center" label="合同单价"></el-table-column>
                        <el-table-column prop="monthlyContractAmount" align="center" label="月合同收入"></el-table-column>
                        <el-table-column prop="annualContractRevenue" align="center" label="年合同收入"></el-table-column>

                        <el-table-column prop="withdrawalDate" align="center" label="撤场日期"></el-table-column>
                        <el-table-column prop="mobilizationDate" align="center" label="进场日期"></el-table-column>
                        <el-table-column prop="settlementMethod" align="center" label="结算方式"></el-table-column>
                        <el-table-column lign="center" label="备注"></el-table-column>
                        <el-table-column prop="partyTitle" align="center" label="合同甲方"></el-table-column>
                        <el-table-column prop="partnerAbbreviation" align="center" label="合同乙方"></el-table-column>
                    </el-table>
                </el-row>
                <el-row style="margin-top: 10px; text-align: center;">
                    <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                        layout=" prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        var organizeFind = async (e, spare8) => {
            var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
                identification: "1",
                organize_id: e,
                spare8: spare8,
            });
            return organizeList.data;
        };
        return {
            //列表相关
            page_num: 1,
            page_size: 10,
            total: 0,
            tableData: [],
            tableDatas: [],
            //组织架构数据
            organizeList: [],
            //条件
            condition: {
                organize_ids: []
            },

            //ids
            organizeS:[],

            //复选框ids
            ids: [],

            //页面相关
            dialogVisible: false,

            download_excel: {
                "架构": "businessDivision",
                "项目": "projectName",
                "开始日期": "contractStartDate",
                "终止日期": "contractEndDate",
                "到期提醒": "isExpire",
                "合同人数": "contractHeadcount",
                "单位": "contractUnit",
                "合同单价": "unitPrice",
                "月合同收入": "monthlyContractAmount",
                "年合同收入": "annualContractRevenue",
                "撤场日期": "withdrawalDate",
                "进场日期": "mobilizationDate",
                "结算方式": "settlementMethod",
                "合同甲方": "partyTitle",
                "合同乙方": "partnerAbbreviation",
            },
            //级联下拉配置
            props: {
                lazy: true,
                async lazyLoad(node, resolve) {
                    if (node.level === 0) {
                        return resolve(await organizeFind('', 'group'));
                    } else {
                        resolve(await organizeFind(node.data.id, ''));
                    }
                },
                value: "id",
                label: "organize_name",
                children: "organizeList",
                checkStrictly: true,
                multiple: true,
            },
        }
    },
    methods: {
        //分页
        handleCurrentChange(val) {
            this.page_num = val;
            this.Find();
        },
        //查询
        async Find() {

            var organizeSe = '';
            if( this.condition.organize_ids != null && this.condition.organize_ids.length >= 1  ){
                this.organizeS = this.condition.organize_ids[this.condition.organize_ids.length - 1];
                organizeSe = this.organizeS[ this.organizeS.length - 1 ];
            }
            
            


            var url = "report/report/findProjectConditionPage";
            var record = {
                pageNum: this.page_num,
                pageSize: this.page_size,
                professionalLineId: "",
                businessDivisionId: "",
                projectId: organizeSe,
                projectName: "",
                
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableData = data.list;
                    this.total = data.total;
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },
        //导表
        async ExportForm() {
            var url = "report/report/findProjectConditionList";
            var record = {
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                debugger
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableDatas = data;
                    this.total = data.total;
                    if (this.tableDatas.length > 0) {
                        this.$message.success("导表成功！文件下载中！");
                        return this.tableDatas;
                    } else {
                        this.$message.success("没有可以导出的数据！");
                        return null;
                    }
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },
        //清除数据
        trash() {
            this.from.data = "";
            this.from.id = "";
        },
        //初始化组织架构及下面的人
        async organizeFind() {
            var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
                identification: "1",
            });
            this.organizeList = this.getTreeData(organizeList.data);

        },
        getTreeData(data) {
            // 循环遍历json数据
            for (var i = 0; i < data.length; i++) {

                if (data[i].organizeList.length < 1) {
                    // children若为空数组，则将children设为undefined
                    data[i].organizeList = undefined;
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(data[i].organizeList);
                }
            }
            return data;
        }
    },
    created() {
        this.Find();
        this.organizeFind();
    }
}
</script>

<style scoped="scoped">
.el-button--goon:focus,
.el-button--goon:hover {
    background: #006E4B;
    color: #fff;
}

.el-button--goon {
    color: #FFF;
    background-color: #006E4B;
    width: 85px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// project_natural_conditions.vue?b9fcf3d4